import { useChatTransport as e } from "../transport/ChatTransportContext.mjs";
import { useQuery as t } from "@maat/store-hooks";
//#region src/hooks/useSummarizeConversation.ts
var n = (n, r) => {
	let { api: i, keys: a } = e();
	return t({
		queryKey: a.summary(n),
		queryFn: () => i.summarize(n),
		enabled: r,
		staleTime: 300 * 1e3
	});
};
//#endregion
export { n as useSummarizeConversation };
